import React from 'react';
import PropTypes from 'prop-types';
import './authlayout.scss';

export function CommonLayout(props) {
  const { children } = props;

  return <div>{children}</div>;
}

CommonLayout.propTypes = {
  children: PropTypes.node.isRequired
};
